export const gunzipSync = () => { throw new Error("gunzipSync: node builtin unavailable in the browser; preload data via provideRawText()"); };